import { decodeToken, getToken, getUser } from '../../services/auth';
import {actionTypes} from './../constants/auth';

const actions = {
    getToken: () => ({
        type: actionTypes.GET_TOKEN
    }),
    setToken: (token) => ({
        type: actionTypes.SET_TOKEN,
        payload: {token}
    }),
    unsetToken: () => ({
        type: actionTypes.UNSET_TOKEN
    }),
    setProfile: (profile)=> ({
        type: actionTypes.SET_PROFILE,
        payload: {profile}
    }),
    setProfileByToken: () => {
        return async (dispatch) => {
            const token = getToken();
            if (token) {
                const { decoded } = await decodeToken(token);
                if (decoded) {
                    const profileData = await getUser(decoded.id);
                    dispatch(actions.setProfile(profileData));
                }
            }
        }
    },
    unsetProfile: () => ({
        type: actionTypes.UNSET_PROFILE
    })
}

export { actions };